import _ from 'lodash';

export function getDefaultMarkBlockedValue(app, selected) {
  if (app == 'asana' || app == 'file') return true;
  if (selected.selectedBlockedFlag !== '') return true;
  if (app == 'jira' && !selected.isBusiness) return true;
}

export function getSelectionValues(configVals, all, map = true) {
  const result = [];
  _(all)
    .map(a => {
      if (typeof map === 'boolean' && !!map) {
        return a.value;
      }

      return !map || typeof map !== 'function' ? a : map(a);
    })
    .forEach(v => {
      if (typeof v === 'string') {
        if (_.indexOf(configVals, v) === -1) {
          result.push(v);
        }
      } else {
        if (_.findIndex(configVals, { _id: v._id }) === -1) {
          result.push(v);
        }
      }
    });

  return result;
}

export default {
  getSelectionValues,
  getDefaultMarkBlockedValue,
};
